<div class="row">
	<div class="col-sm-12">
		{{PERMISSION_ROLE this}}
		<div class="pull-right">
			<a class="h-details btn btn-white" data-toggle="collapse" data-parent="#id-{{id}}" href="#id-details-{{id}}"><i class="glyphicon glyphicon-list"></i></a>
		</div>
	</div>
	<div id="id-details-{{id}}" class="col-sm-12 collapse m-t-10">
		<div class="row">
			<div class="col-sm-6">
			{{#each left}}
			{{#COMPARE @key "!=" "1301"}} {{! hide remote control element }}
				<i class="fa fa-{{#if this}}eye{{else}}check{{/if}} text-success"></i> {{PERMISSION_LABEL @key}}<br>
			{{/COMPARE}}
			{{/each}}
			</div>
			<div class="col-sm-6">
			{{#each right}}
			{{#COMPARE @key "!=" "1301"}} {{! hide remote control element }}
				<i class="fa fa-{{#if this}}eye{{else}}check{{/if}} text-success"></i> {{PERMISSION_LABEL @key}}<br>
			{{/COMPARE}}
			{{/each}}
			</div>
		</div>
	</div>
</div>
